import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', padding: '60px 24px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 48 }}>
          <div style={{ width: 36, height: 36, background: '#00C853', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate(-1)}>
            <svg width="18" height="18" viewBox="0 0 44 44" fill="none">
              <polyline points="4,10 13,34 22,18 31,34 40,10" stroke="#0A0A0A" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          </div>
          <span style={{ fontSize: 18, fontWeight: 500, color: '#FFFFFF' }}>Win<span style={{ color: '#00C853' }}>al</span></span>
        </div>

        <h1 style={{ fontSize: 32, fontWeight: 700, color: '#FFFFFF', marginBottom: 8 }}>Términos y Condiciones</h1>
        <p style={{ fontSize: 13, color: '#666666', marginBottom: 48 }}>Última actualización: Abril 2026</p>

        {[
          {
            title: '1. Aceptación de los términos',
            content: 'Al acceder y usar Winal, aceptás estos términos y condiciones en su totalidad. Si no estás de acuerdo con alguna parte, no podés usar el servicio. El uso continuo del servicio constituye aceptación de cualquier modificación a estos términos.'
          },
          {
            title: '2. Descripción del servicio',
            content: 'Winal es una plataforma de asistencia comercial que permite a equipos de ventas registrar actividad por WhatsApp y a managers visualizar el pipeline en tiempo real. El servicio incluye un bot de WhatsApp con IA, dashboard web, e integraciones opcionales con herramientas de terceros como HubSpot y Slack.'
          },
          {
            title: '3. Cuenta y acceso',
            content: 'Para usar Winal necesitás una cuenta de Google válida. Sos responsable de mantener la confidencialidad de tu cuenta y de todas las actividades que ocurran bajo ella. Debés notificarnos inmediatamente de cualquier uso no autorizado. Winal se reserva el derecho de suspender cuentas que violen estos términos.'
          },
          {
            title: '4. Período de prueba y facturación',
            content: 'Winal ofrece un período de prueba gratuito de 20 días sin necesidad de tarjeta de crédito. Al finalizar el período de prueba, la cuenta se suspende automáticamente hasta que se active un plan de pago. Los planes se cobran mensualmente en USD al tipo de cambio del cierre de mes. El pago se procesa mediante MercadoPago con débito automático.'
          },
          {
            title: '5. Privacidad y datos',
            content: 'Winal recopila y procesa datos comerciales como leads, oportunidades y conversaciones de WhatsApp. Estos datos son propiedad del cliente y son utilizados exclusivamente para proveer el servicio. No vendemos ni compartimos datos con terceros, excepto con los servicios de integración que el cliente configure explícitamente (HubSpot, Slack). Ver nuestra Política de Privacidad para más detalles.'
          },
          {
            title: '6. Uso aceptable',
            content: 'Te comprometés a usar Winal únicamente para fines comerciales legítimos. Está prohibido usar el servicio para enviar spam, mensajes no solicitados, o cualquier actividad que viole las políticas de WhatsApp Business API o las leyes aplicables en tu jurisdicción.'
          },
          {
            title: '7. Limitación de responsabilidad',
            content: 'Winal se provee "tal cual". No garantizamos disponibilidad ininterrumpida del servicio. No somos responsables por pérdidas de datos, negocios o ganancias derivadas del uso o imposibilidad de uso del servicio. Nuestra responsabilidad máxima está limitada al monto pagado en el último mes de suscripción.'
          },
          {
            title: '8. Cancelación',
            content: 'Podés cancelar tu suscripción en cualquier momento desde el panel de administración. La cancelación es efectiva al final del período de facturación vigente. No realizamos reembolsos por períodos parciales. Al cancelar, tus datos se conservan por 30 días antes de ser eliminados permanentemente.'
          },
          {
            title: '9. Modificaciones al servicio',
            content: 'Nos reservamos el derecho de modificar o discontinuar el servicio con 30 días de aviso previo. Para cambios en precios, el aviso será de 60 días. Las notificaciones se enviarán al email registrado en tu cuenta.'
          },
          {
            title: '10. Contacto',
            content: 'Para consultas sobre estos términos, contactanos en hola@winal.app'
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, color: '#FFFFFF', marginBottom: 12 }}>{section.title}</h2>
            <p style={{ fontSize: 14, color: '#888888', lineHeight: 1.8, margin: 0 }}>{section.content}</p>
          </div>
        ))}

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid #1A1A1A', textAlign: 'center' }}>
          <button onClick={() => navigate(-1)} style={{ background: '#00C853', color: '#0A0A0A', border: 'none', borderRadius: 8, padding: '10px 28px', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
            ← Volver
          </button>
        </div>
      </div>
    </div>
  );
}